// extracted by mini-css-extract-plugin
export default {"form":"Security_form__VC4+F"};